import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { VISIONS, ENUMS } from '../../../../../utils/constants';
import Breadcrumbs from '../../../../../components/UI/Breadcrumbs';
import { translate, isNullOrEmpty } from '../../../../../utils/util';
import * as actionsLinePicking from '../../../../../actions/linePickingAction';
import { Row, Modal, Button } from 'react-materialize';
import ButtonUI from '../../../../../components/UI/ButtonUI';
import { getVision } from '../../../../../services/auth';

const SmallPartsFilterByPartnumber = (props) => {
    const [partnumber, setPartnumber] = useState('');
    const [critical, setCritical] = useState(false);
    const [modalOpen, setModalOpen] = useState(props.location?.state?.modal ? props.location?.state?.modal : false);
    let inputFilter;

    useEffect(() => {
        inputFilter.focus();
    }, [inputFilter]);

    useEffect(() => {
        if ((getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD)) {
            setModalOpen(false);
        }
    }, []);

    const applyFilter = () => {
        if (!isNullOrEmpty(partnumber)) {
            props.filter.partnumber = partnumber;
            props.filter.orderType = ENUMS.eOrderType.LinePicking.value;
            props.filter.excludeOrderGrouped = true;
            props.filter.allOrders = true;
            props.setFilterCIM(props.filter);

            if ((getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) || critical) {
                // Redirect para tela de Orders
                props.history.push({
                    pathname: '../orders',
                    state: {
                        kanban: true,
                        printerLabel: true
                    },
                });
            } else {
                props.history.push({
                    state: {
                        filterPartNumber: true,
                        printerLabel: true
                    },
                    pathname: '../onDemand'
                });
            }
        }
    };

    const onConfirm = () => {
        setModalOpen(false);
        setCritical(true);
    };

    const onCancel = () => {
        setModalOpen(false);
        props.history.replace({
            pathname: '../readQrCode',
            state: {
                name: null,
                icon: null,
                label: null,
                required: null,
                route: 'filter/partnumber',
                title: { icon: "mdi mdi-camera-timer", label: translate('line-picking:linepicking.title') },
                subtitle: {
                    icon: "mdi mdi-filter-variant", label: translate('expedition:picking.filterByPartnumber'),
                },
                modal: false
            }
        });
    };

    const subtitlesPickingFilterByPartnumber = () => {
        return [{ icon: "mdi mdi-filter-variant", label: translate('expedition:picking.filterByPartnumber') }];
    }

    return (
        <>
            <Breadcrumbs id="SmallPartsFilterByPartnumber" subtitles={subtitlesPickingFilterByPartnumber()} />
            <div className="container" style={{ marginTop: '40px', }}>
                <div className="row">
                    <div className="col s12">
                        <input
                            id="txtPartnumber"
                            ref={(el) => inputFilter = el}
                            placeholder={translate('expedition:picking.partnumber')}
                            type="number"
                            maxLength="11"
                            onChange={(ev) => { setPartnumber(ev.currentTarget.value); }}
                        />
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <button
                        type="button"
                        className="col s12 m3
                        btn
                        btn-principal
                        waves-effect
                        waves-light"
                        onClick={() => applyFilter()}
                    >
                        {translate('apply', 'general')}
                    </button>
                </div>
            </div>
            <Modal
                id={`modal-id-smallPartsFilterByPartnumber`}
                fixedFooter
                style={{ marginTop: "15px", maxHeight: "60%" }}
                actions={
                    <Row className="center" style={{ height: "60%" }}>
                        <Button className="col s6 btn waves-effect waves-light btn-flat" onClick={() => onCancel()}>
                            {translate('cancel', 'general')}
                        </Button>
                        <ButtonUI onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                    </Row>
                }
                open={modalOpen}>
                <div>
                    <Row className="center">
                        <div className="sixth-text-color center">
                            <span className="col s12">
                                <i className="material-icons large">info_outline</i>
                            </span>
                            <span className="title col s12">{translate('messages.confirmation-critical-care', 'line-picking')}</span>
                        </div>
                    </Row>
                </div>
            </Modal>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.linePickingReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilterCIM: (filter) => {
            dispatch(actionsLinePicking.setFilter(filter));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SmallPartsFilterByPartnumber)));
